import React from 'react';

import {PredictionsOptionViewModel} from "../../../../../domain/full-game/models/prediction/predictions.option.view-model";
import {PredictionResultsBarItem} from "./prediction.results-bar.item";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionResultsBar = ({prediction}) => {
  const {options} = prediction;

  return (
    <div className={classNames(styles.results_bar)}>
      {
        options.map((option: PredictionsOptionViewModel, index: Number) => <PredictionResultsBarItem
          key={option.num}
          option={option}
          isFirst={index === 0}
          isLast={index === options.length - 1}
        />)
      }
    </div>
  )
}
